import Link from 'next/link'

const AddToCartSuccess = () => {
  return (
    <div className='fixed left-1/2 top-1/2 z-10 mx-4 w-full max-w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-xl bg-[#000000CC] p-8 pt-10'>
      <svg
        width='58'
        height='58'
        viewBox='0 0 58 58'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='mx-auto'
      >
        <g clipPath='url(#clip0_127_3644)'>
          <path
            d='M29 0C12.9843 0 0 12.9798 0 29C0 45.0202 12.9843 58 29 58C45.0157 58 58 45.0123 58 29C58 12.9877 45.0157 0 29 0Z'
            fill='#2AD352'
          />
          <path
            d='M2.69315e-05 29C-0.0065195 33.7935 1.1805 38.5131 3.45397 42.7331C6.35044 43.5835 9.35388 44.0142 12.3726 44.0121C29.8066 44.0121 43.9396 29.8791 43.9396 12.4451C43.9422 9.37853 43.498 6.32792 42.621 3.38942C38.4286 1.15633 33.75 -0.00787004 29 4.00404e-05C12.9843 4.00404e-05 2.69315e-05 12.9798 2.69315e-05 29Z'
            fill='#74DA7F'
          />
          <path
            d='M45.5393 24.1948L28.1087 42.4999C27.6337 42.9982 27.063 43.3955 26.4308 43.6681C25.7985 43.9406 25.1178 44.0827 24.4294 44.0858H24.4067C23.7221 44.086 23.0444 43.9486 22.4139 43.6818C21.7834 43.4151 21.213 43.0243 20.7364 42.5327L11.487 33.0058C11.0091 32.5261 10.6312 31.9562 10.3753 31.3293C10.1194 30.7024 9.99057 30.0309 9.99628 29.3537C10.002 28.6766 10.1421 28.0074 10.4085 27.3849C10.675 26.7623 11.0624 26.1989 11.5483 25.7273C12.0342 25.2557 12.609 24.8853 13.2392 24.6377C13.8694 24.39 14.5425 24.2699 15.2195 24.2845C15.8965 24.299 16.5639 24.4479 17.1829 24.7225C17.8019 24.997 18.3601 25.3918 18.8253 25.8838L24.3705 31.5954L38.133 17.143C38.594 16.6487 39.1485 16.2506 39.7643 15.9719C40.3802 15.6932 41.0452 15.5394 41.7208 15.5193C42.3965 15.4993 43.0694 15.6134 43.7007 15.855C44.332 16.0967 44.9091 16.4611 45.3987 16.9272C45.8883 17.3934 46.2805 17.9519 46.5528 18.5706C46.8252 19.1893 46.9721 19.8558 46.9852 20.5317C46.9983 21.2075 46.8772 21.8792 46.629 22.508C46.3809 23.1368 46.0105 23.7101 45.5393 24.1948Z'
            fill='white'
          />
        </g>
        <defs>
          <clipPath id='clip0_127_3644'>
            <rect width='58' height='58' fill='white' />
          </clipPath>
        </defs>
      </svg>

      <p className='mx-auto mt-5 text-center text-base font-semibold text-white'>
        Sản phẩm đã được thêm vào giỏ hàng
      </p>
      <Link
        href='/checkout/cart'
        className='mx-auto mt-5 flex h-9 w-[192px] items-center justify-center rounded-full bg-white text-sm font-semibold text-main'
      >
        Xem giỏ hàng
      </Link>
    </div>
  )
}

export default AddToCartSuccess
